import websitebuilders from ".";

const state = {
    website: null,
    websitebuildersId: [], 
    loading: false
};

export default state;